export const queryKeys = {
  referrals: {
    all: ['referrals'] as const,
    list: (params: Record<string, unknown>) => ['referrals', 'list', params] as const,
    mine: (email: string, params: Record<string, unknown>) =>
      ['referrals', 'mine', email, params] as const,
    detail: (id: number) => ['referrals', 'detail', id] as const,
    activities: (id: number) => ['referrals', 'activities', id] as const,
    metrics: ['referrals', 'metrics'] as const,
    comments: (id: number) => ['referrals', 'comments', id] as const,
    commissions: (id: number) => ['referrals', 'commissions', id] as const,
    myCommissions: (email: string) => ['referrals', 'myCommissions', email] as const,
  },
  graph: {
    myProfile: ['graph', 'myProfile'] as const,
    people: (search: string) => ['graph', 'people', search] as const,
  },
};
